import { cloneDeep } from 'lodash';
import MarkerWithLabel from '@googlemaps/markerwithlabel';
import { geoCodedClinics2 } from '../mocks/geoCodedClinics';
import clinics from '../mocks/clinics';

export const geocodeAddress = (geocoder, a) => {
  const address = encodeURI(a);
  return new Promise((resolve) => {
    geocoder.geocode({ address }, (results, status) => {
      if (status === 'OK') {
        const lat = results[0].geometry.location.lat();
        const lng = results[0].geometry.location.lng();
        resolve({
          lat,
          lng,
        });
      } else {
        resolve({
          failed: true,
        });
      }
    });
  });
};

const codeClinic = (geocoder, c, delay) => {
  const address = `${c.adr_no} ${c.adr_rue} ${c.adr_app} ${c.adr_ville} ${c.adr_province} ${c.adr_cp}`;
  return new Promise((resolve) => {
    setTimeout(() => {
      geocoder.geocode({ address }, (results, status) => {
        if (status === 'OK') {
          const lat = results[0].geometry.location.lat();
          const lng = results[0].geometry.location.lng();
          const clinic = {
            ...cloneDeep(c),
            address,
            lat,
            lng,
          };
          resolve(clinic);
        } else {
          const clinic = {
            ...cloneDeep(c),
            address,
            failed: true,
          };
          resolve(clinic);
        }
      });
    }, delay);
  });
};

const codeClinics = async (geocoder) => {
  const geoClinicPromises = clinics.map((
    clinic, i,
  ) => codeClinic(geocoder, clinic, (1000 * i)));
  const geoClinics = await Promise.all(geoClinicPromises);
  const ok = geoClinics.filter((c) => !c.failed);
  const failed = geoClinics.filter((c) => c.failed);
  // eslint-disable-next-line no-console
  console.log(ok, failed);
};

export const markerType = (c, availableClinicIds, selectedClinicId) => {
  if (c.id === selectedClinicId) {
    return {
      cssClass: ' icon-location--active',
      zIndex: 999,
    };
  }
  if (availableClinicIds.filter((cl) => (cl === c.id)).length === 0) {
    return {
      cssClass: ' icon-location--disabled',
      zIndex: 1,
    };
  }
  return {
    cssClass: '',
    zIndex: 5,
  };
};

export const createMarker = (
  googleMaps, map, markerClickAction, apiClinics, availableClinicIds, c, myLatLng, selectedClinicId,
) => {
  const {
    cssClass,
    zIndex,
  } = markerType(c, availableClinicIds, selectedClinicId);
  const marker = new MarkerWithLabel({
    position: myLatLng,
    icon: ' ',
    map,
    labelContent: `<svg class="demo-icon icon-location${cssClass}" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"></path></svg>`,
    labelAnchor: new googleMaps.Point(-17, -31),
    clinic: c,
    zIndex,
  });

  marker.addListener('click', () => {
    markerClickAction(c);
  });

  return marker;
};

export const generateMarkers = (
  googleMaps, map, markerClickAction, apiClinics, availableClinicIds, selectedClinicId,
) => apiClinics.filter((c) => (c.latitude !== 0 && c.longitude !== 0))
  .map((c) => {
    const myLatLng = {
      lat: c.latitude,
      lng: c.longitude,
    };
    return createMarker(
      googleMaps, map, markerClickAction, apiClinics,
      availableClinicIds, c, myLatLng, selectedClinicId,
    );
  });

export const updateMarkers = (
  googleMaps, map, markerClickAction, apiClinics, availableClinicIds, markers, selectedClinicId,
) => markers.map((m) => {
  const myLatLng = m.position;
  const c = m.clinic;

  m.setMap(null);

  return createMarker(
    googleMaps, map, markerClickAction, apiClinics,
    availableClinicIds, c, myLatLng, selectedClinicId,
  );
});

export const sortGeoCodedClinics = () => geoCodedClinics2.reduce((ac, cv) => {
  const c = cloneDeep(cv);
  c.address = `${cv.adr_no} ${cv.adr_rue} ${cv.adr_app} ${cv.adr_ville} ${cv.adr_province} ${cv.adr_cp}`;
  const group = ac.filter((i) => (i.gps.lat === cv.latitude && i.gps.longitude === cv.lng));
  if (group.length > 0) {
    group[0].clinics.push(c);
  } else {
    ac.push({
      gps: {
        lat: c.latitude,
        lng: c.longitude,
      },
      clinics: [
        c,
      ],
    });
  }
  return ac;
}, []);

export const sortMarkersByDistance = (googleMaps, fromLatLng, markers,
  availableClinicIds, preSelectedClinicId) => {
  const markersDistances = markers.reduce((acc, marker) => {
    const returnedValue = acc;
    const distance = googleMaps
      .geometry.spherical.computeDistanceBetween(marker.position, fromLatLng);

    const distanceMarker = {
      distance,
      marker,
    };

    if (preSelectedClinicId === marker.clinic.id) {
      returnedValue.preSelected.push(distanceMarker);
    } else if (availableClinicIds.filter((cl) => (cl === marker.clinic.id)).length === 0) {
      returnedValue.noAvail.push(distanceMarker);
    } else {
      returnedValue.available.push(distanceMarker);
    }

    return returnedValue;
  }, {
    preSelected: [],
    noAvail: [],
    available: [],
  });

  const closestMarkersNoAvail = markersDistances.noAvail.sort((a, b) => a.distance - b.distance);
  const closestMarkersAvailable = markersDistances.available.sort((
    a, b,
  ) => a.distance - b.distance);

  const closestMarkers = markersDistances.preSelected
    .concat(closestMarkersAvailable)
    .concat(closestMarkersNoAvail);

  return closestMarkers.map((item) => {
    const m = item.marker;
    m.distance = item.distance;
    return m;
  });
};

export default codeClinics;
